import { formatDate, datesFormats } from "./format"

export const getTripDatesInfo = (startDate: Date | string, endDate: Date | string) => {
  const start = new Date(startDate)
  const end = new Date(endDate)

  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    return ""
  }

  const formmatedStartDate = formatDate(start.toISOString(), datesFormats.shortenedMonthNameWithDay)
  const formmatedEndDate = formatDate(end.toISOString(), datesFormats.shortenedMonthNameWithDay)
  return `${formmatedStartDate} - ${formmatedEndDate}, ${start.getFullYear()}`
}
